import React, { useEffect, useState } from 'react';
import { BRAND } from '../../constants';
import './PageLoader.css';

const MIN_VISIBLE_MS = 900;
const FADE_OUT_MS = 450;

const PageLoader = ({ onDone }) => {
  const [progress, setProgress] = useState(0);
  const [leaving, setLeaving] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const startedAt = Date.now();
    let rafId = 0;
    let current = 0;
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;
      cancelAnimationFrame(rafId);

      const wait = Math.max(0, MIN_VISIBLE_MS - (Date.now() - startedAt));
      window.setTimeout(() => {
        setProgress(100);
        setLeaving(true);
        window.setTimeout(() => {
          setHidden(true);
          onDone?.();
        }, FADE_OUT_MS);
      }, wait);
    };

    const tick = () => {
      if (finished) return;
      const ready = document.readyState === 'complete';
      const target = ready ? 100 : Math.min(current + 1.2 + Math.random() * 2.5, 88);
      current += (target - current) * 0.12;
      setProgress(Math.min(100, Math.round(current)));

      if (ready && current >= 99.5) {
        finish();
        return;
      }
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true });
    }

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('load', finish);
    };
  }, [onDone]);

  if (hidden) return null;

  const revealTop = Math.max(0, 100 - progress);

  return (
    <div
      className={`page-loader${leaving ? ' page-loader--leaving' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy={!leaving}
      aria-label={`Cargando ${BRAND.NAME}`}
    >
      <div className="page-loader-mark">
        <img
          src="/logo.png"
          alt=""
          aria-hidden="true"
          className="page-loader-logo page-loader-logo--base"
        />
        <img
          src="/logo.png"
          alt=""
          aria-hidden="true"
          className="page-loader-logo page-loader-logo--color"
          style={{ clipPath: `inset(${revealTop}% 0 0 0)` }}
        />
      </div>
    </div>
  );
};

export default PageLoader;
